<div class="container">
    <div class="format-control">
        <div>{{'dashboard.conditional_formatting' | stringLiterals}}</div>
    </div>
    <div (mouseleave)="onMouseLeave()">
        <div *ngFor="let format of config.conditionalFormattings; index as i;trackBy:trackByFn">
            <div #anchor class="format-detail" (mouseenter)="onMouseEnter(i)">
                <input type="text" class="tam-input" [value]="format.formula" readonly="true"
                    (click)="buildFormat(format)" />
                <div class="button-area" [ngClass]="{'button-area-small':hideBackground}">
                    <div class="color-button-area">
                        <div class="color-button" (click)="addColor($event, format)">
                            <smart-icon name="font-color"></smart-icon>
                        </div>
                        <div class="color-bar" [style.background-color]="format.color"
                            [style.border-color]="format.color"></div>
                    </div>
                    <div class="color-button-area" *ngIf="!hideBackground">
                        <div class="color-button" (click)="addBackgroundColor($event, format)">
                            <smart-icon name="background-color"></smart-icon>
                        </div>
                        <div class="color-bar" [style.background-color]="format.backgroundColor"
                            [style.border-color]="format.backgroundColor"></div>
                    </div>
                </div>
                <div class="simple-button-area" *ngIf="isIPad||mouseOverFormatIndex===i">
                    <smart-icon name="trash" (click)="deleteFormat(i)"></smart-icon>
                </div>
            </div>
            <kendo-popup [anchor]="anchor" *ngIf="(showPopup1||showPopup2)&&selectedFormat.id===format.id">
                <table>
                    <tbody>
                        <tr class="row">
                            <td class="cell" *ngFor="let color of colors|slice:0:13;trackBy:trackByFn">
                                <div class="one-color" [style.background-color]="color"
                                    (click)="chooseColor(color, format)"></div>
                            </td>
                        </tr>
                        <tr class="row">
                            <td class="cell" *ngFor="let color of colors|slice:13:26;trackBy:trackByFn">
                                <div class="one-color" [style.background-color]="color"
                                    (click)="chooseColor(color, format)"></div>
                            </td>
                        </tr>
                        <tr class="row">
                            <td class="cell" *ngFor="let color of colors|slice:26:39;trackBy:trackByFn">
                                <div class="one-color" [style.background-color]="color"
                                    (click)="chooseColor(color, format)"></div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </kendo-popup>
        </div>
    </div>
    <div class="add-icon" (click)="onAddFormat()">
        <smart-icon name="add-cycle"></smart-icon>
    </div>
</div>